import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { BootstrapModalService } from '../../global/services/_app/bootstrap-modal/bootstrap-modal.service';

// rendered by the shell as a sibling of .modal-body, outside the scrollable area,
// so the footer stays put (sticky) while only the body content scrolls.
// skip the wrapper when there is no template — an empty .modal-footer still
// draws a dashed line on top of a nested card footer (add organisation)
@Component({
    selector: 'bootstrap-modal-footer',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="modal-footer" *ngIf="footerTemplate">
            <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
        </div>
    `
})
export class BootstrapModalFooterComponent implements OnInit, OnDestroy {
    private readonly onDestroy$ = new Subject<void>();

    public footerTemplate: any = null;

    constructor(
        private readonly bootstrapModalService: BootstrapModalService
    ) { }

    ngOnInit(): void {
        this.bootstrapModalService.footerTemplate$
            .pipe(takeUntil(this.onDestroy$))
            .subscribe((template) => {
                this.footerTemplate = template;
            });
    }

    ngOnDestroy(): void {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    }
}
